import React from 'react';
import PropTypes from 'prop-types';
import {Button, Col} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons';

const UpdateComp = ({children, action}) => {
  return (
    <Col xs={2}>
      <Button className="btn-update" onClick={action}>
        <FontAwesomeIcon icon={faPencilAlt} color="#329aef" size="sm" />
      </Button>
      {children}
    </Col>
  );
};

UpdateComp.propTypes = {
  children: PropTypes.any.isRequired,
  action: PropTypes.func.isRequired,
};

export default UpdateComp;
